import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './index.css';

// Web Vitals 초기화 (프로덕션에서만)
if (import.meta.env.PROD) {
  import('./lib/analytics').then(({ initWebVitals }) => {
    initWebVitals({
      debug: import.meta.env.DEV,
      endpoint: '/api/analytics', // 실제 엔드포인트로 변경
      sampleRate: 0.1, // 10% 샘플링
    });
  });
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
